import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Fil d'Ariane visuel (le JSON-LD BreadcrumbList est posé par chaque page)
export default function Breadcrumb({ items }) {
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumb" className="mb-8">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs uppercase tracking-[0.14em] font-medium">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-400" />}
            {item.to ? (
              <Link
                to={item.to}
                className="text-brand-navy/60 hover:text-brand-navy transition-colors duration-300"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-brand-golddark">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
